import { render } from "./Catalog.vue?vue&type=template&id=d0273304&scoped=true&ts=true"
import script from "./Catalog.vue?vue&type=script&lang=ts"
export * from "./Catalog.vue?vue&type=script&lang=ts"

import "./Catalog.vue?vue&type=style&index=0&id=d0273304&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0273304"]])

export default __exports__